import AxiosInstance from 'utils/AxiosInstance'
import qs from 'qs'
import * as types from './constants'
import {
  getCoursesModule,
  getGroupsModule,
  selectCourseManagerGroupsLocationGroupCourse,
  getCourseManagerCoursesModule,
  setCoursesUpdated,
  setGroupsUpdated,
  resetRefetchManagerReportsCourses,
  refetchManagerReportsCourses,
} from '../ManagerReport/actions'
import { getReport } from '../EmployeeReport/actions'

export const onChangeItem = (value, sectionId, itemId) => (dispatch) =>
  dispatch(onChange('value', value, sectionId, itemId))
export const onChangeComment = (value, sectionId, itemId) => (dispatch) =>
  dispatch(onChange('comment', value, sectionId, itemId))
export const onChangeSection = (property, value) => ({
  type: types.CHECKLIST_UPDATE,
  property,
  value,
})
export const resetChecklistData = () => ({ type: types.CHECKLIST_RESET_DATA })
export const secondLevelApproval = () => ({ type: types.CHECKLIST_APPROVE })
export const setReferredFromManagerReport = (value) => ({
  type: types.SET_REFERRED_FROM_MANAGER_REPORT,
  value,
})

export const getChecklist = (query) => {
  return (dispatch, getState) => {
    query = qs.parse(query.slice(1))
    dispatch({ type: types.CHECKLIST_LOADED, loaded: false })
    const { user_id, course_id, group_id } = query
    console.log('leart35', user_id, course_id, group_id, query)

    group_id
      ? dispatch(onChangeSection('groupId', group_id))
      : dispatch(onChangeSection('courseId', course_id))

    const endpointUrl = group_id
      ? `/manager-reports/checklist/group?groupId=${group_id}&userId=${user_id}`
      : `/manager-reports/checklist?courseId=${course_id}&userId=${user_id}`
    AxiosInstance.get(endpointUrl).then((response) => {
      if (response.submission) {
        dispatch({
          type: types.CHECKLIST,
          checklist: response.submission,
        })

        dispatch({
          type: types.SET_CERTIFY_TIME,
          value: response.certify_time,
        })
        dispatch({
          type: types.SET_CHECKLIST_APPROVAL,
          waitingForApproval:
            response.waiting_for_approval === 1 ? true : false,
          approvalPrivilege: response.approval_privilege === 1 ? true : false,
          approvedBy: response.approved_by,
        })
        group_id
          ? dispatch(onChangeSection('groupId', group_id))
          : dispatch(onChangeSection('courseId', course_id))
      } else {
        const state = getState()
        dispatch({ type: types.CHECKLIST_USER, user: response.user })
        dispatch(
          onChangeSection(
            'managerName',
            state.auth.user
              ? `${state.auth.user.first_name} ${state.auth.user.last_name}`
              : ''
          )
        )

        dispatch({
          type: types.CHECKLIST,
          checklist: response.checklist,
        })
        dispatch({
          type: types.SET_CHECKLIST_APPROVAL,
          waitingForApproval:
            response.waiting_for_approval === 1 ? true : false,
          approvalPrivilege: response.approval_privilege === 1 ? true : false,
          approvedBy: response.approved_by,
        })
        dispatch({
          type: types.SET_CERTIFY_TIME,
          value: response.certify_time,
        })
        group_id
          ? dispatch(onChangeSection('groupId', group_id))
          : dispatch(onChangeSection('courseId', course_id))
      }
      dispatch({ type: types.CHECKLIST_LOADED, loaded: true })
    })
  }
}

const onChange = (name, value, sectionId, itemId) => {
  return (dispatch, getState) => {
    const { sections } = getState().checklist
    const sectionIndex = sections.findIndex(
      (section) => section.id === sectionId
    )
    const itemIndex = sections[sectionIndex].items.findIndex(
      (item) => item.id === itemId
    )

    const newSections = [
      ...sections.slice(0, sectionIndex),
      {
        ...sections[sectionIndex],
        items: [
          ...sections[sectionIndex].items.slice(0, itemIndex),
          { ...sections[sectionIndex].items[itemIndex], [name]: value },
          ...sections[sectionIndex].items.slice(itemIndex + 1),
        ],
      },
      ...sections.slice(sectionIndex + 1),
    ]

    dispatch({ type: types.CHECKLIST_SECTION_UPDATE, sections: newSections })
  }
}

const makeRequest = () => {
  return (dispatch, getState) => {
    const { checklist } = getState()

    const {
      selectedCoursesLocations,
      selectedTab,
      selectedGroupsGroup,
      selectedGroupGroupsLocations,
      selectedCourseManagerGroupsLocationGroups,
      courseModule,
      groupsModule,
    } = getState().managerReport

    const { access, second_access } = getState().auth.user

    const apiUrl = checklist.groupId
      ? '/manager-reports/checklist/submit/group'
      : '/manager-reports/checklist/submit'

    AxiosInstance.post(apiUrl, {
      userId: checklist.user.id,
      courseId: checklist.courseId,
      groupId: checklist.groupId,
      checklist: JSON.stringify(checklist),
      status: checklist.status,
    }).then(() => {
      if (courseModule || groupsModule) {
        if (access === 2 || second_access === 2) {
          if (selectedTab === 'courses') {
            dispatch(getCourseManagerCoursesModule())
          } else if (
            selectedTab === 'groups' &&
            selectedCourseManagerGroupsLocationGroups
          ) {
            dispatch(
              selectCourseManagerGroupsLocationGroupCourse(
                selectedCourseManagerGroupsLocationGroups
              )
            )
          }
        } else {
          if (selectedTab === 'courses' && selectedCoursesLocations.length) {
            dispatch(getCoursesModule(selectedCoursesLocations))
          } else if (
            selectedTab === 'groups' &&
            selectedGroupGroupsLocations &&
            selectedGroupsGroup
          ) {
            dispatch(getGroupsModule())
          }
        }

        dispatch(setGroupsUpdated(true))
        dispatch(setCoursesUpdated(true))
        dispatch(refetchManagerReportsCourses())
      }
    })
  }
}

export const saveChecklist = () => {
  return (dispatch) => {
    dispatch(onChangeSection('status', 'save'))
    dispatch(makeRequest())
  }
}

export const submitChecklist = () => {
  return (dispatch, getState) => {
    const { sections, managerName } = getState().checklist

    const emptyItem = sections.find((section) =>
      section.items.find((item) => item.value.trim().length === 0)
    )

    let language = {}
    getState().language.language // eslint-disable-line
      ? (language = getState().language.language.data)
      : null

    if (emptyItem) {
      alert(language.alerts ? language.alerts.fill_all_fields : null)

      return
    }

    if (managerName.trim().length === 0) {
      alert(language.alerts ? language.alerts.type_manager_name : null)

      return
    }

    dispatch(onChangeSection('status', 'submit'))
    dispatch(makeRequest())
  }
}

export const resetChecklist = () => {
  return (dispatch, getState) => {
    const { user, courseId, groupId } = getState().checklist
    const {
      selectedCoursesLocations,
      selectedTab,
      selectedGroupsGroup,
      selectedGroupGroupsLocations,
      selectedCourseManagerGroupsLocationGroups,
      courseModule,
      groupsModule,
    } = getState().managerReport

    const { access, second_access } = getState().auth.user
    const apiUrl = groupId
      ? '/manager-reports/checklist/group/reset'
      : '/manager-reports/checklist/reset'

    AxiosInstance.post(apiUrl, {
      userId: user.id,
      courseId: courseId,
      groupId,
      courseId,
      status: 'reset',
    }).then((response) => {
      dispatch({ type: types.CHECKLIST_RESET })
      dispatch({ type: types.CHECKLIST_USER, user: response.user })
      dispatch({ type: types.CHECKLIST, checklist: response.checklist })
      if (courseModule || groupsModule) {
        if (access === 2 || second_access === 2) {
          if (selectedTab === 'courses') {
            dispatch(getCourseManagerCoursesModule())
          } else if (
            selectedTab === 'groups' &&
            selectedCourseManagerGroupsLocationGroups
          ) {
            dispatch(
              selectCourseManagerGroupsLocationGroupCourse(
                selectedCourseManagerGroupsLocationGroups
              )
            )
          }
        } else {
          if (selectedTab === 'courses' && selectedCoursesLocations.length) {
            dispatch(getCoursesModule(selectedCoursesLocations))
          } else if (
            selectedTab === 'groups' &&
            selectedGroupGroupsLocations &&
            selectedGroupsGroup
          ) {
            dispatch(getGroupsModule())
          }
        }

        dispatch(setGroupsUpdated(true))
        dispatch(setCoursesUpdated(true))
      }
    })
  }
}

export const approveChecklist = () => {
  return (dispatch, getState) => {
    const { user, courseId } = getState().checklist

    AxiosInstance.post('/manager-reports/checklist/approve', {
      userId: user.id,
      courseId: courseId,
    }).then((response) => {
      dispatch(getReport(user.id))
      dispatch({
        type: types.SET_CHECKLIST_APPROVAL,
        waitingForApproval: false,
        approvalPrivilege: false,
      })
    })
  }
}
